import PropTypes from 'prop-types';
import Event from './Event';
import ParamContext from '../overview_pages/ParamContext';
import { useContext, useMemo } from 'react';
import { monthAndYear } from '../../shared';

const EventList = ({ results }) => {
  if (!results || results.length === 0) return 'No events found';

  if (results.results) results = results.results;

  const { archived } = useContext(ParamContext);

  const sortedResults = useMemo(
    () =>
      [...results].sort((a, b) =>
        archived
          ? new Date(b.start_time) - new Date(a.start_time)
          : new Date(a.start_time) - new Date(b.start_time)
      ),
    [results, archived]
  );

  const elearningEvents = useMemo(
    () => sortedResults.filter((e) => e.e_learning),
    [sortedResults]
  );
  const regularEvents = useMemo(
    () =>
      sortedResults.filter(
        (e) => !e.e_learning && e.course_repetition !== 'regularly'
      ),
    [sortedResults]
  );
  const ongoingEvents = useMemo(
    () =>
      sortedResults.filter(
        (e) => !e.e_learning && e.course_repetition === 'regularly'
      ),
    [sortedResults]
  );

  const renderEvent = (item) => (
    <Event key={item.fake_key.toString()} item={item} />
  );

  const getStartMonth = (item) => monthAndYear(item.start_time);

  const regularEventsByMonth = () => {
    let lastMonth = '';
    return regularEvents.map((item, index) => {
      const currentMonth = getStartMonth(item);
      const showMonth = !archived && currentMonth !== lastMonth;
      lastMonth = currentMonth;

      return (
        <div key={item.fake_key.toString()}>
          {showMonth && <div className="month">{currentMonth}</div>}
          {renderEvent(item)}
        </div>
      );
    });
  };

  const showSidebar = elearningEvents.length > 0 || ongoingEvents.length > 0;

  const firstClass = archived ? 'archiv-list' : 'search-hits';
  const regularEventsClass = showSidebar ? 'col-md-8' : 'col-md-12';
  const sidebarClass = regularEvents.length > 0 ? 'col-md-4' : 'col-md-12';

  return (
    <div
      className={
        elearningEvents.length > 0 || ongoingEvents.length > 0 ? 'row' : ''
      }
    >
      {regularEvents.length > 0 && (
        <div className={`${firstClass} ${regularEventsClass}`}>
          {regularEventsByMonth()}
        </div>
      )}

      {showSidebar && (
        <div className={`${firstClass} ${sidebarClass}`}>
          {elearningEvents.length > 0 && (
            <>
              <div className="month">
                {I18n.t('event_page.details.e_learning')}
              </div>
              {elearningEvents.map(renderEvent)}
            </>
          )}
          {ongoingEvents.length > 0 && (
            <>
              <div className="month">
                {I18n.t('event_page.details.regularly')}
              </div>
              {ongoingEvents.map(renderEvent)}
            </>
          )}
        </div>
      )}
    </div>
  );
};

EventList.propTypes = {
  results: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

EventList.defaultProps = {
  results: [],
};

export default EventList;
